import React, { FC } from 'react'
import { ListElement } from '../../templateEditor.types'
import { TemplateEditorInlineEditApi } from '../../hooks/document/useTemplateEditorInlineEdit'
import { defaultEditorTheme } from '../../templateEditor.theme'
import { listItemHeight, listItemSlotWidth } from '../placementMetrics'
import { toDisplaySize } from '../../templateEditor.utils'
import { EditableInlineText } from './EditableInlineText'
import elementStyles from './templateEditorElementViews.jcss'

type Props = {
    element: ListElement
    scale: number
    inlineEdit: TemplateEditorInlineEditApi
}

export const TemplateEditorListView: FC<Props> = ({ element, scale, inlineEdit }) => {
    const theme = defaultEditorTheme
    const fontSize = toDisplaySize(element.fontSize, scale)
    const gap = toDisplaySize(element.gap, scale)
    const indent = toDisplaySize(element.indent, scale)
    const horizontal = element.orientation === 'horizontal'
    const slotW = toDisplaySize(listItemSlotWidth(theme), scale)
    const itemH = toDisplaySize(
        listItemHeight({ fontSize: element.fontSize, lineHeight: 1.5, gap: element.gap }, theme) - element.gap,
        scale
    )

    return (
        <div
            className={horizontal ? elementStyles.listHorizontal : elementStyles.listVertical}
            style={{ gap, fontSize, color: element.color }}
        >
            {element.items.map((item, index) => {
                const target = { type: 'list-item' as const, elementId: element.id, index }
                const editing = inlineEdit.isEditing(target)

                return (
                    <div
                        key={index}
                        className={elementStyles.listItem}
                        style={
                            horizontal
                                ? { width: slotW, flex: '0 0 auto' }
                                : { paddingLeft: indent, minHeight: itemH, flex: '0 0 auto' }
                        }
                        onDoubleClick={(event) => {
                            event.stopPropagation()
                            inlineEdit.startInlineEdit(target)
                        }}
                    >
                        {!horizontal && element.markerType === 'bullet' && (
                            <span className={elementStyles.listBullet}>•</span>
                        )}
                        {!horizontal && element.markerType === 'number' && (
                            <span className={elementStyles.listBullet}>{index + 1}.</span>
                        )}
                        <EditableInlineText
                            value={item}
                            editing={editing}
                            className={elementStyles.editableText}
                            onCommit={inlineEdit.commitInlineEdit}
                            onCancel={inlineEdit.cancelInlineEdit}
                        />
                    </div>
                )
            })}
        </div>
    )
}
